// extracted by mini-css-extract-plugin
export default {"container":"SPInput_container__Wad3r","focus":"SPInput_focus__vwgzE","input":"SPInput_input__hoDrd","icon":"SPInput_icon__FEWzJ","icons":"SPInput_icons__WnV5q"};